import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createSuper";
import { ValueWithRandom } from "../../ValueWithRandom";
export var LifeDuration = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(LifeDuration, _ValueWithRandom);
  var _super = _createSuper(LifeDuration);
  function LifeDuration() {
    var _this;
    _classCallCheck(this, LifeDuration);
    _this = _super.call(this);
    _this.random.minimumValue = 0.0001;
    _this.sync = false;
    return _this;
  }
  _createClass(LifeDuration, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      _get(_getPrototypeOf(LifeDuration.prototype), "load", this).call(this, data);
      if (data.sync !== undefined) {
        this.sync = data.sync;
      }
    }
  }]);
  return LifeDuration;
}(ValueWithRandom);